import React, { useState } from 'react';
import { Tag } from 'rsuite';
import type { BagelAiFlowRoute } from '../../types/aiFlow';

type Props = {
  routes: BagelAiFlowRoute[];
};

/** "Possible next steps" — the outgoing edges from a selected flow node. Click a row to expand its explanation. */
export default function RouteList({ routes }: Props) {
  const [expandedKey, setExpandedKey] = useState<string | null>(null);

  if (routes.length === 0) return null;

  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: '#64748b', marginBottom: 6 }}>
        POSSIBLE NEXT STEPS
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {routes.map(route => {
          const key = `${route.targetId}-${route.label ?? ''}`;
          const expanded = expandedKey === key;
          const canExpand = Boolean(route.targetDescription);
          return (
            <div key={key}>
              <button
                type="button"
                onClick={() => canExpand && setExpandedKey(expanded ? null : key)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  fontSize: 13,
                  width: '100%',
                  padding: '2px 0',
                  background: 'none',
                  border: 'none',
                  textAlign: 'left',
                  cursor: canExpand ? 'pointer' : 'default',
                  color: 'inherit',
                }}
              >
                {canExpand ? (
                  <span style={{ color: '#94a3b8', fontSize: 11, width: 10 }}>
                    {expanded ? '▾' : '▸'}
                  </span>
                ) : (
                  <span style={{ width: 10 }} />
                )}
                {route.label ? <Tag color="violet">{route.label}</Tag> : null}
                <span>→ {route.targetTitle}</span>
              </button>
              {expanded && route.targetDescription ? (
                <p
                  style={{
                    margin: '2px 0 6px 16px',
                    fontSize: 12,
                    color: '#475569',
                    lineHeight: 1.5,
                  }}
                >
                  {route.targetDescription}
                </p>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
